module.exports = __webpack_public_path__ + "static/media/footerLogo.081064d0.png";